<template>
  <page-wrap wrapClass="register">
    <land-box :isRegPage="true">
      <div slot="main" class="form-wrap">
        <div class="mock-tab">
          <div class="tab-text">注册账号</div>
          <div class="tab-line"></div>
        </div>
        <el-form
          ref="registerForm"
          :rules="registerRules"
          :model="registerForm"
          hide-required-asterisk
        >
          <el-form-item class="form-item" prop="phoneNum">
            <el-input
              v-model.trim="registerForm.phoneNum"
              type="text"
              placeholder="请输入手机号"
            />
          </el-form-item>
          <el-form-item prop="verifyCode" class="form-item vcode-item">
            <div class="ou-expand">
              <el-input
                v-model.trim="registerForm.verifyCode"
                type="text"
                placeholder="请输入验证码"
              />
            </div>
            <el-button
              class="vcode-btn"
              :class="[vCodeBtnDisabled ? 'biger' : '']"
              @click="openBioReg"
              :disabled="vCodeBtnDisabled"
              >{{ vCodeBtnText }}
            </el-button>
          </el-form-item>
          <el-form-item class="form-item" prop="username">
            <el-input
              v-model.trim="registerForm.username"
              auto-complete="off"
              type="text"
              placeholder="请输入账号"
              readonly
              onfocus="this.removeAttribute('readonly');"
            />
          </el-form-item>
          <el-form-item class="form-item" prop="password">
            <el-input
              v-model="registerForm.password"
              auto-complete="off"
              placeholder="请输入密码"
              @keyup.enter.native="handleRegister"
              show-password
            />
          </el-form-item>
          <el-form-item class="form-item" prop="confirmPassword">
            <el-input
              v-model="registerForm.confirmPassword"
              show-password
              placeholder="请再次输入密码"
              @keyup.enter.native="handleRegister"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="foot" class="foot-wrap">
        <el-button
          :loading="regLoading"
          type="primary"
          class="submit-btn"
          @click.native.prevent="handleRegister"
        >
          <span v-if="!regLoading">注册</span>
          <span v-else>注 册 中...</span>
        </el-button>
        <div class="form-bottom ou-flex-lr">
          <div>
            <el-checkbox
              name="agree"
              v-model="hasAgree"
              @change="switchAgree"
            />
            <span>
              <span>阅读并同意</span>
              <span class="web-link active" @click="modalShow = true"
                >服务协议、隐私政策</span
              >
              <!-- <el-link :underline="false" type="primary" @click="madaoShow = true">服务协议、隐私政策</el-link> -->
            </span>
          </div>
          <span class="web-link" @click="goLogin"> 去登录> </span>
        </div>
      </div>
    </land-box>
    <el-dialog
      title="服务协议 | 隐私政策"
      :visible.sync="modalShow"
      width="900px"
      append-to-body
      @opened="initObserver"
      :before-close="beforeModalClose"
      :destroy-on-close="true"
      class="ou-modal"
    >
      <div class="protocol-scroll-wrap">
        <div class="scroll-view">
          <danger-view></danger-view>
          <div class="scroll-bottom-line" ref="scrollBottomLine"></div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="needReadAll" @click="modalConfirm"
          >同意</el-button
        >
      </div>
    </el-dialog>
    <verify
      ref="bioReg"
      :mode="'pop'"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '330px', height: '155px' }"
      @success="bioRegPass"
    />
  </page-wrap>
</template>

<script>
import PageWrap from "./components/PageWrap";
import LandBox from "./components/LandBox";
import DangerView from "./components/DangerView";
import Verify from "@/components/verifition/Verify";
import {
  apiSendMsgCode,
  apiRegister,
  apiGetAuthConfig,
} from "@/api/user/login";
import { encrypt } from "@/utils/jsencrypt";
const mobile_reg =
  /^1(3[0-9]|4[01456879]|5[0-3,5-9]|6[2567]|7[0-8]|8[0-9]|9[0-3,5-9])\d{8}$/;
export default {
  name: "register",
  components: { PageWrap, LandBox, DangerView, Verify },
  data() {
    return {
      registerForm: {
        phoneNum: "",
        verifyCode: "",
        username: "",
        password: "",
        confirmPassword: "",
      },
      verifyKey: "",
      vCodeBtnDisabled: false,
      canResendSeconds: 0,
      timer: null,
      hasAgree: false,
      bioVerification: "",
      registerRules: {
        phoneNum: [
          { required: true, trigger: "blur", message: "请输入手机号" },
          {
            pattern: mobile_reg,
            trigger: "blur",
            message: "请输入正确的手机号码",
          },
        ],
        verifyCode: [
          { required: true, trigger: "blur", message: "请输入验证码" },
        ],
        username: [
          { required: true, trigger: "blur", message: "请输入您的账号" },
          {
            min: 2,
            max: 20,
            message: "账号长度必须介于 2 和 20 之间",
            trigger: "blur",
          },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: "账号不能为汉字",
            trigger: "blur",
          },
          {
            pattern: new RegExp("^[A-z0-9]*$"),
            message: "只能输入数字或英文！!",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          { min: 8, max: 20, validator: this.validPassword, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, trigger: "blur", message: "请再次输入您的密码" },
          { required: true, validator: this.equalToPassword, trigger: "blur" },
        ],
      },
      regLoading: false,
      modalShow: true,
      needReadAll: true,
      hasViewBottomObserver: null,
      isPwdEncrypt: "default",
      isValidateBlock: "default",
    };
  },
  created() {
    this.$nextTick(() => {
      this.initObserver();
    });
  },
  watch: {},
  mounted() {
    apiGetAuthConfig().then((res) => {
      Object.assign(this.$data, res.data);
    });
    // 暂定默认显示
    // setTimeout(() => {
    //   this.modalShow = true
    // }, 500)
  },
  computed: {
    vCodeBtnText() {
      return this.vCodeBtnDisabled
        ? this.canResendSeconds + "秒后重新获取"
        : "获取验证码";
    },
  },
  methods: {
    equalToPassword(rule, value, callback) {
      if (this.registerForm.password !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    },
    validPassword(rule, value, callback) {
      // let reg = /^(?=.*\d)(?=.*[a-zA-Z]).{8,20}$/;
      let reg = /(?=.*[a-z_])(?=.*\d)(?=.*[^a-z0-9_])[\S]{8,20}/i;
      if (!reg.test(value)) {
        callback(new Error("密码必须包含字母和数字和特殊符号，8-20个字符"));
      } else {
        callback();
      }
    },
    // 事件：获取验证码按钮
    openBioReg() {
      // 先校验手机号, 通过则打开滑块验证控件
      this.$refs.registerForm.validateField("phoneNum", (error, field) => {
        if (!error.length) {
          this.isValidateBlock
            ? this.$refs.bioReg.show()
            : this.getVerifyCode();
        }
      });
    },
    // 滑块式生物识别, 通过则请求短信验证码
    bioRegPass(result) {
      this.bioVerification = result.captchaVerification;
      this.getVerifyCode(result.captchaVerification);
    },
    // 请求短信验证码
    getVerifyCode(bioVerification) {
      if (this.isValidateBlock && !bioVerification) {
        this.$message.error("安全验证失败");
        return;
      }
      // 因为前置逻辑验证过这里可不校验手机，健壮性起见二次验证
      this.$refs.registerForm.validateField("phoneNum", (error, field) => {
        if (!error.length) {
          let params = {
            phoneNum: this.registerForm.phoneNum,
            type: 3,
          };
          params = this.isValidateBlock
            ? { ...params, verification: bioVerification }
            : params;
          apiSendMsgCode(params).then((res) => {
            // 请求验证码成功则开启重发保护倒计时
            let { key, retrySendIntervalSeconds } = res.data;
            this.verifyKey = key;
            this.startCountdown(retrySendIntervalSeconds);
          });
        }
      });
    },
    // 验证码重发保护
    startCountdown(seconds) {
      const _this = this;
      this.canResendSeconds = seconds || 60;
      this.vCodeBtnDisabled = true;
      this.timer = setInterval(() => {
        if (_this.canResendSeconds === 1) {
          _this.vCodeBtnDisabled = false;
          clearInterval(_this.timer);
          _this.timer = null;
        }
        _this.canResendSeconds--;
      }, 1000);
    },
    // 事件：注册按钮、回车键
    handleRegister() {
      // 先验证用户协议是否已阅
      if (!this.hasAgree) {
        let msg = this.$message.error("请先阅读并同意用户协议、隐私政策");
        setTimeout((_) => {
          msg.close();
          this.modalShow = true;
        }, 1000);
        return;
      }
      this.$refs.registerForm.validate().then((res) => {
        let {
          phoneNum: phoneNumber,
          password,
          username: userName,
          verifyCode: code,
        } = this.registerForm;
        let data = {
          phoneNumber,
          code,
          key: this.verifyKey,
          userName,
          password: this.isPwdEncrypt ? encrypt(password) : password,
          customType: "pc",
        };
        this.regLoading = true;
        apiRegister(data)
          .then((res) => {
            this.$alert(
              `<span>恭喜你，您的账号 <span style="color:#212121;">${userName}</span> 注册成功！</span>`,
              "系统提示",
              {
                dangerouslyUseHTMLString: true,
                type: "success",
                showClose: false,
              }
            )
              .then(() => {
                this.$router.push("/login");
              })
              .catch(() => {});
          })
          .catch((err) => {
            console.log("注册失败", err);
          })
          .finally((_) => (this.regLoading = false));
      });
    },
    modalConfirm() {
      this.hasAgree = true;
      this.modalShow = false;
    },
    // 事件：用户协议勾选切换
    switchAgree(e) {
      // 因为有前置完整阅读后才关闭modal的逻辑，一般不会出现此种情况
      if (e && this.needReadAll) {
        this.modalShow = true;
        this.$nextTick((_) => {
          this.hasAgree = false;
        });
      }
    },
    // 事件：点击X关闭用户协议
    beforeModalClose(close) {
      this.hasViewBottomObserver.disconnect();
      this.hasViewBottomObserver = null;
      close();
      /* 2022-07-13 需求调整: 此处逻辑弃用, 用户可随时关闭协议模态框
      if (!this.needReadAll) {
        // 如果当前已经阅读完即可关闭
        close()
      } else {
        // 如果已同意, 表示这是主动二次打开协议弹窗, 可随时关闭
        if (this.hasAgree) {
          close()
        } else {
          this.$alert(`<span><span style="color:#212121;">请先完整阅读协议内容</span></span>`, '系统提示', {
            dangerouslyUseHTMLString: true,
            type: 'warning',
            showClose: false,
          })
        }
      }
      */
    },
    initObserver() {
      this.hasViewBottomObserver = new IntersectionObserver((entries) => {
        let entrie = entries[0];
        console.log("当前监测", entries);
        if (!entrie.intersectionRatio) return false;
        this.needReadAll = false;
      });
      this.hasViewBottomObserver.observe(this.$refs.scrollBottomLine);
    },
    goLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped lang="scss">
.protocol-scroll-wrap {
  .scroll-view {
    height: 480px;
    width: 840px;
    background-color: #ffffff;
    border: 1px solid #f2f2f2;
    padding: 18px 24px;
    box-sizing: border-box;
    overflow-y: auto;
    .scroll-bottom-line {
      height: 1px;
      width: 100%;
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      background-color: rgba(240, 240, 240, 1);
    }
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 0px rgba(210, 210, 240, 0.4);
      border-radius: 2px;
      background-color: rgba(210, 210, 240, 0.4);
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      box-shadow: inset 0 0 3px rgba(24, 24, 24, 0.3);
      background-color: rgba(24, 24, 24, 0.2);
    }
  }
}

.ou-modal ::v-deep {
  .el-dialog {
    margin-top: calc((100vh - 602px) / 2) !important;
  }
  .el-dialog__header {
    padding: 20px 30px 10px;
    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }
  }
  .el-dialog__body {
    padding: 10px 30px 0;
  }
  .el-dialog__footer {
    padding: 16px 30px;
    text-align: center;
  }
  .el-button--primary {
    width: 200px;
    font-size: 16px;
    padding: 8px 20px;
    background: #2e9adb;
    border-radius: 6px;
    &.is-disabled {
      background: #a0cfff;
    }
  }
}

.mock-tab {
  margin-bottom: 42px;
  position: relative;
  .tab-text {
    font-size: 32px;
    padding: 0 5px;
    width: fit-content;
    height: 48px;
    line-height: 40px;
    text-align: center;
    letter-spacing: 4px;
    box-sizing: border-box;
    color: #409eff;
  }
  .tab-line {
    height: 3px;
    background-color: #409eff;
    width: 148px;
    position: absolute;
    bottom: 1px;
  }
}
@media screen and (max-height: 899px) {
  .mock-tab {
    margin-bottom: 24px;
  }
}
</style>
